//
//
//
//
//
//
//
//
//

import EventCard from './EventCard'
import WebinarCard from './WebinarCard'
import PodcastCard from './PodcastCard'
import DefaultCard from './DefaultCard'

export default {
	name: "Card",
		props: ["item"],
		components: {
			appEventCard: EventCard,
			appWebinarCard: WebinarCard,
			appPodcastCard: PodcastCard,
			appDefaultCard: DefaultCard
		},
    computed: {
			cardComponentType: function() {
				switch (this.item.contentType.id) {
					case "Ahla.Event":
						return "app-event-card";
					case "Ahla.Webinar":
						return "app-webinar-card";
					case "Ahla.PodcastEpisode":
						return "app-podcast-card";
					default:
						return "app-default-card";
				}
			}
    }
};
